export enum PointTransactionType {
  CHECKIN = 10,
  LOGIN = 20,
  CHECKIN_EXTRA = 30,
  POST = 100,
  COMMENT = 110,
  VOTE = 120,
  REBLOG = 130,
  DELEGATION = 150,
  REFERRAL = 160,
  COMMUNITY = 170,
  TRANSFER_SENT = 998,
  TRANSFER_INCOMING = 999,
  MINTED = 991,
}
